// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@sc/Overrides/Widgets/Cart/CartLineCardExpanded";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndTextWrapper = {
    ...cartLineSharedStyles.extendedUnitNetPriceHeadingAndTextWrapper,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.noPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
            color: "primary.main",
        },
    },
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-bottom: 10px;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.badgesWrapper = {
    ...cartLineSharedStyles.badgesWrapper,
};

cartLineCardExpandedStyles.hideLineNoteLink = {
    ...cartLineSharedStyles.hideLineNoteLink,
};

cartLineCardExpandedStyles.showLineNoteLink = {
    ...cartLineSharedStyles.showLineNoteLink,
};

cartLineCardExpandedStyles.notify = {
    ...cartLineSharedStyles.errorMessage,
};

cartLineCardExpandedStyles.quantity = {
    editableQuantityTextField: {
        ...(TRANSLATE_OBJECT as any),
    },
    questionIconStyles: {
        css: css`
            margin-right: 0;
        `,
    },
};
